import Head from 'next/head';
import Footer from '~/components/Footer/Footer';
import Header from '~/components/Header/Header';
import BackTop from '~/components/BackTop/BackTop';

import css from './LayoutBasic.less';

const React = require('react');

const Favicon = require('public/favicon.ico');

const Layout = props => {
  const { children } = props;
  return (
    <div>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, height=device-height"
        />
        <meta name="renderer" content="webkit" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <link rel="shortcut icon" href={Favicon} type="image/x-icon" />
        <link rel="stylesheet" href="/style/desktop/reset.css" />
        <link rel="stylesheet" href="/style/desktop/common.css" />
      </Head>
      {/* 页面公用头部组件 */}
      <Header />
      <div className={css.content}>
        <div className={css.contentMain}>{children}</div>
      </div>
      {/* 页面公用底部组件 */}
      <Footer />
      {/* 返回页面顶部组件 */}
      <BackTop />
    </div>
  );
};

export default Layout;
